// redux/actions/flashMessageActions.js
import axios from 'axios';
import toast from 'react-hot-toast';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_FLASH_REQUEST = 'FETCH_FLASH_REQUEST';
export const FETCH_FLASH_SUCCESS = 'FETCH_FLASH_SUCCESS';
export const FETCH_FLASH_FAILURE = 'FETCH_FLASH_FAILURE';

export const CREATE_FLASH_REQUEST = 'CREATE_FLASH_REQUEST';
export const CREATE_FLASH_SUCCESS = 'CREATE_FLASH_SUCCESS';
export const CREATE_FLASH_FAILURE = 'CREATE_FLASH_FAILURE';

export const UPDATE_FLASH_REQUEST = 'UPDATE_FLASH_REQUEST';
export const UPDATE_FLASH_SUCCESS = 'UPDATE_FLASH_SUCCESS';
export const UPDATE_FLASH_FAILURE = 'UPDATE_FLASH_FAILURE';

export const DELETE_FLASH_REQUEST = 'DELETE_FLASH_REQUEST';
export const DELETE_FLASH_SUCCESS = 'DELETE_FLASH_SUCCESS';
export const DELETE_FLASH_FAILURE = 'DELETE_FLASH_FAILURE';

// Fetch Flash Messages
export const fetchFlashMessages = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_FLASH_REQUEST });
    const token = localStorage.getItem('token');

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/admin/flash-message-list`, {
        headers: { authorization: token },
      });
      dispatch({ 
        type: FETCH_FLASH_SUCCESS, 
        payload: response.data.data || [] 
      });
    } catch (error) {
      dispatch({
        type: FETCH_FLASH_FAILURE,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
};

// Create Flash Message
export const createFlashMessage = (flashData) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');

    dispatch({ type: CREATE_FLASH_REQUEST });

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/create-flash-message`,
        flashData,
        {
          headers: {
            authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch({ type: CREATE_FLASH_SUCCESS });
      // toast.success('Flash message created successfully');
      return response.data;
    } catch (error) {
      dispatch({
        type: CREATE_FLASH_FAILURE,
        payload: error.response?.data?.message || 'Failed to create flash message',
      });
      toast.error(error.response?.data?.message || 'Failed to create flash message');
      throw error;
    }
  };
};

// Update Flash Message
export const updateFlashMessage = (flashData) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');

    dispatch({ type: UPDATE_FLASH_REQUEST });

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/update-flash-message`,
        flashData,
        {
          headers: {
            authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch({ type: UPDATE_FLASH_SUCCESS });
      // toast.success('Flash message updated successfully');
      return response.data;
    } catch (error) {
      dispatch({
        type: UPDATE_FLASH_FAILURE,
        payload: error.response?.data?.message || 'Failed to update flash message',
      });
      toast.error(error.response?.data?.message || 'Failed to update flash message');
      throw error;
    }
  };
};

// Delete Flash Message
export const deleteFlashMessage = (id) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');

    dispatch({ type: DELETE_FLASH_REQUEST });

    try {
      await axios.post(
        `${BASE_URL}/v1/api/delete-flash-message`,
        { id },
        {
          headers: {
            authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch({ type: DELETE_FLASH_SUCCESS });
      // toast.success('Flash message deleted successfully');
    } catch (error) {
      dispatch({
        type: DELETE_FLASH_FAILURE,
        payload: error.response?.data?.message || 'Failed to delete flash message',
      });
      toast.error(error.response?.data?.message || 'Failed to delete flash message');
      throw error;
    }
  };
};